module.exports = __webpack_public_path__ + "img/loupe.1a30d49a.svg";